import React, { JSX, useEffect, useState } from 'react';
import '../style.css';

export const TextEffect = ({ text }: { text: string }) => {
  const [Items, setItems] = useState<JSX.Element[]>([]);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const itemsElements = Array.from({ length: 20 }).map((_, i) => {
      const left = Math.random() * 100;
      const delay = Math.random() * 2;

      return (
        <span 
          key={i}
          className="item-nav-theme"
          style={{
            fontSize: "25px",
            left: `${left}%`,
            animationDelay: `${delay}s`,
            bottom: `-${Math.random() * 20}px`,
            fontFamily: '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif',
          }}>
          {text}
        </span>
      );
    });

    setItems(itemsElements);

    const timeout = setTimeout(() => {
      setVisible(false);
    }, 5000); // dura 5 segundos

    return () => clearTimeout(timeout);
  }, []);

  if (!visible) return null;

  return <div className="nav-theme-container">{Items}</div>;
};


